const UNAUTHENTICATED_STATUS = 401;
const isUserFacingClientError = (response) => {
    const status = response?.status;
    if (typeof status !== 'number')
        return false;
    return status >= 400 && status < 500 && status !== UNAUTHENTICATED_STATUS;
};
export const getApiErrorMessage = (error, fallback) => {
    const response = error?.response;
    if (!isUserFacingClientError(response))
        return fallback;
    const message = response?.data?.message;
    if (typeof message === 'string' && message.trim())
        return message;
    return fallback;
};
export const notifyStoreError = (dispatch, message, error) => {
    console.error(message, error);
    dispatch('toastfy/activeErrorNotification', { text: getApiErrorMessage(error, message) }, { root: true });
    return null;
};
